// Shared overlay frame for any module detail panel. Full-bleed inset by
// 56/24/24/24 from the viewport (top accounts for the 56px header).
//
// Layout: rows = [auto detail-head] + [1fr scrollable detail-body]
//   detail-head : eyebrow + serif h1 + close button
//   detail-body : overflow-auto, padding 16, grid gap 16

export function DetailShell({ eyebrow, title, headerAction, onClose, children }) {
  return (
    <div
      className="absolute inset-[0_24px_24px_24px] bg-paper border border-ink grid grid-rows-[auto_minmax(0,1fr)] min-h-0 z-20"
      role="dialog"
      aria-label={title}
    >
      <div className="flex items-end justify-between gap-3 px-4 pt-3 pb-2.5 border-b border-ink">
        <div>
          <div className="font-mono text-eyebrow uppercase text-ink-3">{eyebrow}</div>
          <h1 className="detail-h1 font-serif text-h1-detail mt-1 leading-none">{title}</h1>
        </div>
        <div className="flex items-end gap-2 flex-shrink-0">
          {headerAction}
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="w-[28px] h-[28px] grid place-items-center border border-ink font-mono text-base hover:bg-danger hover:border-danger hover:text-white transition-colors duration-100"
          >
            ×
          </button>
        </div>
      </div>

      <div className="overflow-auto p-4 grid gap-4 content-start min-h-0">{children}</div>
    </div>
  );
}

export default DetailShell;
